export enum OTPTypes {
  MOM, MOMDoc, MsgDoc, SignDocs
}
